import {
	Header as HeaderComponent,
	LogoLink,
} from '@audio-network/componentlibrary'
import React, { useEffect, useState } from 'react'

import DesktopNavBar from './DesktopNavBar/DesktopNavBar'
import HeaderActions from './HeaderActions/HeaderActions'
import Link from 'next/link'
import MobileMenu from './MobileMenu/MobileMenu'
import clientGetToggleFromCookie from '@/utils/cookies/getToggleFromCookie'
import { sendAnalytics } from '@audio-network/analytics'
import styles from './Header.module.css'
import { useTranslation } from 'next-i18next'

const Header = (): JSX.Element => {
	const { t } = useTranslation(['navigation'])
	const [showSoundEffects, setShowSoundEffects] = useState(false)

	const handleClick = (noun: string): void => {
		sendAnalytics({
			noun,
			pastTenseVerb: 'Clicked',
			eventParameters: {
				Location: 'Music App Navigation',
			},
		})
	}

	useEffect(() => {
		const soundEffectsEnabled = clientGetToggleFromCookie('SoundEffects')
		setShowSoundEffects(soundEffectsEnabled)
	}, [])

	return (
		<HeaderComponent className={styles.header} id="music-app-header">
			<MobileMenu showSoundEffects={showSoundEffects} />
			<Link href="/" legacyBehavior passHref>
				<LogoLink
					href="/"
					aria-label={t('go-to-dashboard')}
					className={styles.mobileLogoLink}
					onClick={() => handleClick('Logo')}
				/>
			</Link>
			<DesktopNavBar showSoundEffects={showSoundEffects} />
			<HeaderActions />
		</HeaderComponent>
	)
}

export default Header
